import { cn } from '../../helpers/utils.js'
import type { ProductCardProps } from './types.js'
import { Button, Picture, Text } from '../../components/index.js'

const CpnProductCard = (props: ProductCardProps) => {
  const { content, cns } = props

  return (
    <div className={cn('cpn-card-container relative box-border w-[177px] px-2 pb-3 pt-4 text-center', cns?.container)}>
      {content?.map((item, index) => {
        switch (item.type) {
          case 'tag':
            return <Text key={index} as="div" html={item.text} />
          case 'image':
            return (
              <Picture
                key={index}
                source={`${item.image}, ${item.imageMob || item.image} 768`}
                className={cn('mx-auto h-[100px]')}
                alt={''}
                imgClassName={cn('h-full object-cover')}
              />
            )
          case 'title':
            return (
              <Text key={index} as="div" html={item.text} className={cn('text-[14px] font-semibold text-[#333]')} />
            )
          case 'price':
            return (
              <div className="mt-3">
                <Text html={`${item.text}`} className={cn('text-[14px] font-semibold text-[#333]')} />
              </div>
            )
          case 'buttons':
            return (
              <div className="mt-2 flex flex-col gap-2">
                {item.buttons?.map((button, index) => (
                  <Button key={index} variant={button.variant} className="w-full" onClick={button.onClick}>
                    {button.text}
                  </Button>
                ))}
              </div>
            )
        }
      })}
    </div>
  )
}

export default CpnProductCard
